/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

var UpperLeftToLowerRight = 0;
var UpperRightToLowerLeft = 1;
var LowerLeftToUpperRight = 2;
var LowerRightToUpperLeft = 3;

export default class ZoomDirections extends EmberObject {
  startingPosition = null;
  currentPosition = null;

  @computed('startingPosition', 'currentPosition') get direction() {
    var currentPosition = this.currentPosition;
    var startingPointX = this.startingPosition.x;
    var startingPointY = this.startingPosition.y;
    var result = null;
    if (currentPosition.x > startingPointX && currentPosition.y > startingPointY) {
      result = UpperLeftToLowerRight;
    } else if (currentPosition.x < startingPointX && currentPosition.y > startingPointY) {
      result = UpperRightToLowerLeft;
    } else if (currentPosition.x > startingPointX && currentPosition.y < startingPointY) {
      result = LowerLeftToUpperRight;
    } else if (currentPosition.x < startingPointX && currentPosition.y < startingPointY) {
      result = LowerRightToUpperLeft;
    }
    return result;
  }

  @computed('direction') get rectangleCoordinates() {
    var direction = this.direction;
    var result = null;
    if (direction === UpperLeftToLowerRight) {
      result = this.upperLeftToLowerRight;
    } else if (direction === UpperRightToLowerLeft) {
      result = this.upperRightToLowerLeft;
    } else if (direction === LowerLeftToUpperRight) {
      result = this.lowerLeftToUpperRight;
    } else if (direction === LowerRightToUpperLeft) {
      result = this.lowerRightToUpperLeft;
    }
    return result;
  }

  @computed('startingPosition', 'currentPosition') get upperLeftToLowerRight() {
    var startingPosition = this.startingPosition;
    var currentPosition = this.currentPosition;
    var result = { x: null, y: null, width: null, height: null };
    result.x = startingPosition.x;
    result.y = startingPosition.y;
    result.width = currentPosition.x - startingPosition.x;
    result.height = currentPosition.y - startingPosition.y;
    return result;
  }

  @computed('startingPosition', 'currentPosition') get upperRightToLowerLeft() {
    var startingPosition = this.startingPosition;
    var currentPosition = this.currentPosition;
    var result = { x: null, y: null, width: null, height: null };
    result.x = currentPosition.x;
    result.y = startingPosition.y;
    result.width = startingPosition.x - currentPosition.x;
    result.height = currentPosition.y - startingPosition.y;
    return result;
  }

  @computed('startingPosition', 'currentPosition') get lowerLeftToUpperRight() {
    var startingPosition = this.startingPosition;
    var currentPosition = this.currentPosition;
    var result = { x: null, y: null, width: null, height: null };
    result.x = startingPosition.x;
    result.y = currentPosition.y;
    result.width = currentPosition.x - startingPosition.x;
    result.height = startingPosition.y - currentPosition.y;
    return result;
  }

  @computed('startingPosition', 'currentPosition') get lowerRightToUpperLeft() {
    var startingPosition = this.startingPosition;
    var currentPosition = this.currentPosition;
    var result = { x: null, y: null, width: null, height: null };
    result.x = currentPosition.x;
    result.y = currentPosition.y;
    result.width = startingPosition.x - currentPosition.x;
    result.height = startingPosition.y - currentPosition.y;
    return result;
  }

  getRectangleCoordinates(currentPosition) {
    this.set('currentPosition', currentPosition);
    return this.rectangleCoordinates;
  }
}
